var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"clock"},[_vm._v("\n    "+_vm._s(_vm.type === 'remaining' ? _vm.remainingTime : _vm.elapsedTime)+" "),_c('i',{staticClass:"fa fa-clock-o",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }